// TODO Бахнуть дефолтный заголовок с авторизацией только для девелоп
import { preparePhoneNumberForServerRequest } from "../utils"
import { checkResponseStatus, detectNetError, NetError } from "./utils"
import config from "../config"

/**
 * Отправка смс кода на номер телефона
 * @param {string} phone
 * @returns {Promise<Object>} smsCodeData - Данные об отправке
 * @returns {boolean} smsCodeData.send - Был ли код отправлен
 * @returns {number} smsCodeData.secondsToRepeat - Через сколько секунд можно перезапросить данные
 */
export async function sendSmsCode(phone, recaptchaV3, recaptchaV2) {
	return await fetch("/api-v2/sms/sendRegistrationCode/", {
		method: "POST",
		body: JSON.stringify({
			phone: preparePhoneNumberForServerRequest(phone),
			recaptchaResponse: recaptchaV3,
			recaptchaResponseV2: recaptchaV2,
		}),
		headers: {
			Authorization: "Basic cXJubDpxd2ExNTQK",
		},
	})
		.then(rawResponse => rawResponse.json())
		.then(response => {
			if (response.status === 200) {
				return response.payload
			}
			if (response.status === 400) {
				return {
					send: true,
					secondsToRepeat: 60,
				}
			}

			// Остальные ситуации означают ошибку отправки
			throw new NetError("Sms not sending")
		})
}

/**
 * Валидация кода подтверждения смс
 * @param {string} smsCode - Код введенный пользователем
 * @param {string} phone - Номер телефона, на который отправляется код
 * @returns {Promise<boolean>} - Корректнен ли введенный код
 */
export async function checkSmsCode(smsCode, phone) {
	return fetch("/api_controller/?module=sms&method=checkRegistrationCode", {
		method: "POST",
		body: JSON.stringify({
			code: smsCode,
			phone,
		}),
		headers: {
			Authorization: "Basic cXJ0ZXN0bG9naW46MXFhenhzdzI",
		},
	})
		.then(rawResponse => rawResponse.json())
		.then(checkResponseStatus)
		.then(response => response.payload)
		.catch(error => {
			throw error
		})
}

/**
 * Создание облака
 */
export async function createCloud(registryData) {

	const utms = localStorage.getItem(config.UTM_MARKS)
		? JSON.parse(localStorage.getItem(config.UTM_MARKS))
		: null

	const urlFirstPage = localStorage.getItem(config.WSC_PAGES)
		? new URL(JSON.parse(localStorage.getItem(config.WSC_PAGES))[0].url)
		: null

	const firstPagePath = urlFirstPage
		? urlFirstPage.origin + urlFirstPage.pathname
		: null

	const referrer = localStorage.getItem(config.WSC_REFERRER)
		? new URL(localStorage.getItem(config.WSC_REFERRER)).hostname
		: null

	// В соответствии с API, сначала нужно отправить запрос на регистрацию пользователя
	const userInfo = await fetch(
		"/api_controller/?module=registration&method=common",
		{
			method: "POST",
			body: JSON.stringify({
				...registryData,
				utm: { ...utms },
				// Номер делефона нужно отформатировать
				phone: preparePhoneNumberForServerRequest(registryData.phone),
				source: {
					firstPagePath: firstPagePath,
					referrer: referrer},
			}),
			headers: {
				Authorization: "Basic cXJ0ZXN0bG9naW46MXFhenhzdzI",
			},
		}
	)
		.then(rawResponse => rawResponse.json())
		.then(checkResponseStatus)
		.then(response => response.payload)

	// С данными полученными после регистрации отправить запрос на развертывание облака.
	await fetch("/api_controller/?module=cloud&method=deploy", {
		method: "POST",
		body: JSON.stringify({
			cloudId: userInfo.cloud.id,
			token: userInfo.token,
		}),
		headers: {
			Authorization: "Basic cXJ0ZXN0bG9naW46MXFhenhzdzI",
		},
	})

	return {
		cloudName: userInfo.cloud.url,
		trialPeriodInDays: userInfo.days,
	}
}

/**
 * Создание заявки в amoCrm, если на любом шаге регистрации произошла ошибка сервера
 * @returns {Promise<boolean>}
 */
export async function createRegistryErrorAmoOffer(registryData) {
	return fetch("/api_controller/?module=user&method=registrationErrorRequest", {
		method: "POST",
		headers: {
			Authorization: "Basic cXJ0ZXN0bG9naW46MXFhenhzdzI",
		},
		body: JSON.stringify({
			phone: registryData.phone || null,
			email: registryData.email || null,
			name: registryData.name || null,
			promoCode: registryData.promoCode || null,
		}),
	})
		.then(detectNetError)
		.then(response => response.status === 200)
}

export async function sendAdditionalFormData(registryData) {
	return fetch("/api_controller/?module=crm&method=additionalData", {
		method: "POST",
		headers: {
			Authorization: "Basic cXJ0ZXN0bG9naW46MXFhenhzdzI",
		},
		body: JSON.stringify({
			email: registryData.email || null,
			businessType: registryData.businessType || null,
			city: registryData.city || null,
			status: registryData.status || null,
			places: registryData.places || null,
		}),
	})
		.then(detectNetError)
		.then(response => response.status === 200)
}
